export default "__VITE_ASSET__rtl_Ae$7__"